import _ from "lodash"

/**
 * mark the all invalid & required fields as danger 
 * (to show the msg)
 * 
 * @param {object} form 
 */
export let showInvalidFields = (form) => {
  _.forEach(form, (field) => {
    if (field.required && field.state !== "has-success")
      _.set(field, "state", "has-danger")
  })
}

/**
 * update the data of each form field
 * 
 * @param {object} form 
 * @param {object} data 
 */
export let updateForm = (form, data) => {
  return _.forEach(form, (field) => {
    updateFieldValue(field, data)
  })
}

/**
 *
 * @param {object} field
 * @param {object} formData
 * @param {string} className
 */
export let updateFieldValue = (field, formData, className) => {

  let type = _.get(field, 'type')

  let name = (type === 'Checkboxes' || type === 'RadioButtons' || type === 'Dropdown') ? 'options' : 'value'

  if (type === 'Dropdown2') {
    let {isMulti , options} = field

    let formVal = _.get(formData, `${field.stateName}`, isMulti ? [] : '')

    let selectedOpts = isMulti ? _.filter(options, opt => formVal.includes(opt.value)) : _.find(options, opt => formVal == opt.value)

    _.set(field, name, selectedOpts)


  } else {

    _.set(field, name, _.get(formData, `${field.stateName}`, "")) // changeable
    _.set(field, `original_${name}`, _.get(formData, `${field.stateName}`, "")) // fixed
  }
  
  _.set(field, "state", className ?? "has-success")

}

// -------------------

/**
 * assign a value to a speceific field
 * 
 * @param {object} form 
 * @param {string} field 
 * @param {any} value 
 * @param {string} className 
 * @returns {object} form after update
 */
export let setFieldValue = (form, field, value, className) => {

  let type = _.get(form, `${field}.type`)

  switch (type) {
    case "Checkboxes":
      {

        let options = _.get(form, `${field}.options`, [])

        options = _.map(options, opt => {

          if (opt.id === value)
            opt.checked = !opt.checked // update the check state

        })

      }
      break;

    case 'RadioButtons':
      {

        let options = _.get(form, `${field}.options`, [])

        // only check the selected option id
        options = _.map(options, opt => opt.checked = (opt.id === value))

      }
      break;

    case 'TextInputDate':
    case 'TextInputDueDate':
      {
        _.set(form, `${field}.value`, toFirebaseTimestamp(value))
        _.set(form, `${field}.state`, className)
      }
      break;

    default:
      {
        let isPassField = _.get(form, `${field}.stateName`)

        if (isPassField === "confirmPassword") { // check if the pass & comfirm are match
          let passVal = _.get(form, `password.value`)
          className = passVal === value? 'has-success' : 'has-danger'
        }

        if (isPassField === "password") { // clear the confirm when the pass was changed
          _.set(form, `confirmPassword.value`, '')
        }

        _.set(form, `${field}.value`, value)
        _.set(form, `${field}.state`, _.isEmpty(value) ? '' : className)
      }
      break;

  }


  return form
}

/**
 * get each field [key and value] to send it to database if all required fields are exist,
 * otherwise 
 * 
 * 
 * @param {object} form
 * @returns {formStatus}
 * @returns {object} formStatus.data
 * @returns {boolean} formStatus.isValid
 */
export let getFieldsValues = (formFields) => {

  let data = {}, isValid = true

  formFields = _.values(formFields)

  for (let i = 0; i < formFields.length; i++) {

    let field = formFields[i]
    
    let { type, required, state } = field

    // skip the text tags
    if (type === "Header" || type === "Label" || type === "Paragraph" || type === "LineBreak") continue

    if (type === "Checkboxes" || type === "RadioButtons") {

      let hasCheckedOption = _.find(field.options, opt => opt.checked)

      if (required && !hasCheckedOption) {
        isValid = false
        break
      }

      data[field.stateName] = field.options

    } else {

      if (required && !field.value || state == 'has-danger') {
        isValid = false
        break
      }
      
      data[field.stateName] = (type === "TextInputDueDate") || (type === 'TextInputDate') ? toFirebaseTimestamp(field.value) : (field.value ?? '')

    }

  }

  return {isValid, data}
} 

/**
 * convert moment date to firebase timestamp
 * 
 * @param {moment} date 
 * @requires {Timestamp}
 */
export let toFirebaseTimestamp = (date) => date? window.firebaseTime.fromDate(date.toDate()) : ''
